import * as React from "react";

function Calculate(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      stroke="none"
    >
      <path
        d="M18.17 1H5.824C4.267 1 3 2.096 3 3.443v17.114C3 21.904 4.267 23 5.825 23h12.35C19.732 23 21 21.904 21 20.557V3.443C21 2.096 19.733 1 18.17 1zm1.417 19.561c0 .676-.636 1.222-1.413 1.222H5.825c-.781 0-1.412-.55-1.412-1.222V3.443c0-.676.636-1.222 1.412-1.222h12.35c.781 0 1.412.55 1.412 1.222v17.118z"
        stroke="none"
      />
      <path
        d="M17.357 4.602H6.652a.719.719 0 00-.705.732v4.262c0 .405.315.732.705.732h10.705c.39 0 .705-.327.705-.732V5.334a.719.719 0 00-.705-.732zm-.706 4.261H7.357V6.067h9.294v2.796zM7.772 12.173h-1.12a.719.719 0 00-.705.733c0 .405.315.733.705.733h1.12c.39 0 .706-.327.706-.733a.719.719 0 00-.706-.733zM12.565 12.173h-1.12a.719.719 0 00-.706.733c0 .405.315.733.705.733h1.12c.391 0 .706-.327.706-.733a.719.719 0 00-.705-.733zM17.357 12.173h-1.12a.719.719 0 00-.706.733c0 .405.315.733.705.733h1.12c.391 0 .706-.327.706-.733a.719.719 0 00-.705-.733zM7.772 15.536h-1.12a.719.719 0 00-.705.732c0 .406.315.733.705.733h1.12c.39 0 .706-.327.706-.733a.719.719 0 00-.706-.732zM12.565 15.536h-1.12a.719.719 0 00-.706.732c0 .406.315.733.705.733h1.12c.391 0 .706-.327.706-.733a.719.719 0 00-.705-.732zM17.357 15.536h-1.12a.719.719 0 00-.706.732c0 .406.315.733.705.733h1.12c.391 0 .706-.327.706-.733a.719.719 0 00-.705-.732zM7.772 18.898h-1.12a.719.719 0 00-.705.733c0 .405.315.732.705.732h1.12c.39 0 .706-.327.706-.732a.719.719 0 00-.706-.733zM12.565 18.898h-1.12a.719.719 0 00-.706.733c0 .405.315.732.705.732h1.12c.391 0 .706-.327.706-.732a.719.719 0 00-.705-.733zM17.357 18.898h-1.12a.719.719 0 00-.706.733c0 .405.315.732.705.732h1.12c.391 0 .706-.327.706-.732a.719.719 0 00-.705-.733z"
        stroke="none"
      />
    </svg>
  )
}

const MemoCalculate = React.memo(Calculate);
export default MemoCalculate;
